<template>
    <div class="sf-filters-skip-link sr-only">
        <a :href="target">
            <slot>
                {{ t('filters-skip-link') }}
            </slot>
        </a>
    </div>
</template>

<script setup>
defineProps({
    target: {
        type: String,
        default: '#body'
    }
});

const { t } = useI18n({
    useScope: 'local'
});
</script>

<style src="./filters-skip-link.less" lang="less"></style>

<i18n lang="json">
{
    "nl": {
        "filters-skip-link": "Sla filters over"
    },
    "en": {
        "filters-skip-link": "Skip filters"
    }
}
</i18n>
